import { DocumentPermissionNotificationItem } from "@/components/doc/left-sidebar/top-menu/notifications/DocumentPermissionNotificationItem";
import { InviteNotificationItem } from "@/components/doc/left-sidebar/top-menu/notifications/InviteNotificationItem";
import { MembershipNotificationItem } from "@/components/doc/left-sidebar/top-menu/notifications/MembershipNotificationItem";
import { MentionNotificationItem } from "@/components/doc/left-sidebar/top-menu/notifications/MentionNotificationItem";
import { MessageNotificationItem } from "@/components/doc/left-sidebar/top-menu/notifications/MessageNotificationItem";

import type { Notification } from "@/api";

export function NotificationItem({ notification }: { notification: Notification }) {
  const { entity } = notification;
  if (!entity) return null;

  switch (entity.typename) {
    case "Invite":
      return <InviteNotificationItem notification={notification} entity={entity} />;
    case "DocumentPermission":
      return <DocumentPermissionNotificationItem notification={notification} entity={entity} />;
    case "MessageNotification":
      return <MessageNotificationItem notification={notification} entity={entity} />;
    case "Membership":
      return <MembershipNotificationItem notification={notification} entity={entity} />;
    case "Mention":
      return <MentionNotificationItem notification={notification} entity={entity} />;
    default:
      return null;
  }
}
